// TODO: combine this with forYouContent/helpers/market-temp-helpers.ts

import { LegacyThemeType } from '@homebotapp/hb-react-component-catalog'
// Helper functions for color interpolation
const hexToRgb = (hex: string): { r: number; g: number; b: number } => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }
    : { r: 0, g: 0, b: 0 }
}

const rgbToHex = (r: number, g: number, b: number): string => {
  return (
    '#' +
    [r, g, b]
      .map(x => {
        const hex = x.toString(16)
        return hex.length === 1 ? '0' + hex : hex
      })
      .join('')
  )
}

export const interpolateColor = (value: number, theme: LegacyThemeType): string => {
  const colors = [
    { pos: 0, color: theme.isLightThemeType ? '#105998' : '#5AA3EE' },
    { pos: 50, color: theme.isLightThemeType ? '#5D00C5' : '#BDA8FF' },
    { pos: 100, color: theme.isLightThemeType ? '#AD0054' : '#F7749E' }
  ]

  if (value <= colors[0].pos) return colors[0].color
  if (value >= colors[2].pos) return colors[2].color

  let i = 1
  while (value > colors[i].pos) i++

  const lower = colors[i - 1]
  const upper = colors[i]
  const range = upper.pos - lower.pos
  const fraction = (value - lower.pos) / range

  const lowerRgb = hexToRgb(lower.color)
  const upperRgb = hexToRgb(upper.color)

  const r = Math.round(lowerRgb.r + (upperRgb.r - lowerRgb.r) * fraction)
  const g = Math.round(lowerRgb.g + (upperRgb.g - lowerRgb.g) * fraction)
  const b = Math.round(lowerRgb.b + (upperRgb.b - lowerRgb.b) * fraction)

  return rgbToHex(r, g, b)
}
